import { Button, Modal, ModalProps } from "react-bootstrap";

export default function InfoMessage(props:ModalProps) {
    return (
        <Modal
        {...props}
        size="lg"
        centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="My Modal">{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{props.text}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
    )
  }